/**
 * Utilitaires pour la conversion de couleurs haute précision (Lab space)
 */

export const rgbToLab = (r, g, b) => {
  // Normalisation RGB
  let [nr, ng, nb] = [r / 255, g / 255, b / 255].map(v => 
    v > 0.04045 ? Math.pow((v + 0.055) / 1.055, 2.4) : v / 12.92
  );

  // Vers XYZ
  let x = (nr * 0.4124 + ng * 0.3576 + nb * 0.1805) * 100;
  let y = (nr * 0.2126 + ng * 0.7152 + nb * 0.0722) * 100;
  let z = (nr * 0.0193 + ng * 0.1192 + nb * 0.9505) * 100;

  // Vers Lab
  const f = (t) => t > 0.008856 ? Math.pow(t, 1/3) : (7.787 * t) + (16 / 116);
  
  // Point blanc D65
  x /= 95.047; y /= 100.000; z /= 108.883;

  return [
    (116 * f(y)) - 16,
    500 * (f(x) - f(y)),
    200 * (f(y) - f(z))
  ];
};

export const deltaE = (labA, labB) => {
  const deltaL = labA[0] - labB[0];
  const deltaA = labA[1] - labB[1];
  const deltaB = labA[2] - labB[2];
  return Math.sqrt(deltaL * deltaL + deltaA * deltaA + deltaB * deltaB);
};